export const AI_SITE_WIZARD_SITE_PROP = 'ai_site_wizard';
export const aiSiteWizardSitePropValues = {
  ENABLED: 'enabled',
  COMPLETED: 'completed',
  SKIPPED: 'skipped',
  INITIATED: 'initiated',
};
